<div [ngClass]="{ 'card card-custom': !data }">
  <div
    *ngIf="!data"
    class="card-header"
    cdkDrag
    cdkDragRootElement=".cdk-overlay-pane"
    cdkDragHandle
  >
    <div class="card-title">
      <h3 class="card-label" translate>{{ getTitle() }}</h3>
    </div>
  </div>
  <div [class.navi-hover]="!fromHis" [class.scroll]="!fromHis" [class.card-body]="!fromHis">
    <div class="card-body-progress">
      <mat-spinner [diameter]="20"></mat-spinner>
    </div>

    <form [formGroup]="contactForm" class="form form-group-seperator-dashed">
      <kt-alert
        *ngIf="hasFormErrors"
        type="warn"
        [showCloseButton]="true"
        [duration]="10000"
        (closeAl)="onAlertClose()"
      >
        <span translate="GLOBAL.FORM_ERROR"
          >Oh snap! Change a few things up and try submitting again.</span
        >
      </kt-alert>
      <kt-alert
        *ngIf="hasSubmissionErrors && !hasFormErrors"
        type="warn"
        [duration]="30000"
        [showCloseButton]="true"
        (closeAl)="onAlertClose()"
      >
        <ul>
          <li *ngFor="let err of submissionErrorObj">{{ err.error | translate }}</li>
        </ul>
      </kt-alert>

      <input type="hidden" formControlName="entity_id" />

      <div class="form-section form-section-first whole-form">
        <div *ngIf="data" class="col-lg-9 col-xl-6">
          <div
            class="image-input image-input-outline image-input-changed"
            style="background-image: url(/assets/media/users/blank.jpg)"
          >
            <div
              class="image-input-wrapper"
              [ngStyle]="{ 'background-image': 'url(' + basicInfo.avatar + ')' }"
            ></div>
          </div>
        </div>

        <div class="form-group row cards-inside-doctor-form">
          <div class="col-lg-12 card-header-doctor-form">
            <h4 translate="CONTACT.FORM.BASIC_INFO">Basic Info</h4>
          </div>
          <div class="col-lg-4 kt-margin-bottom-20-mobile">
            <mat-form-field class="mat-form-field-fluid" appearance="fill">
              <mat-label>{{ 'PATIENT.INPUT.FIRST_NAME' | translate }}</mat-label>
              <input
                matInput
                placeholder="Enter First Name"
                formControlName="first_name"
                [ngStyle]="{
                  'background-color': data
                    ? showChanges(prevData.first_name, nextData.first_name)
                      ? '#f5ebc4'
                      : ''
                    : ''
                }"
              />
              <mat-error
                >{{ 'PATIENT.INPUT.FIRST_NAME' | translate }}
                <strong>{{ 'PATIENT.VALIDATION.REQUIRED' | translate }}</strong>
              </mat-error>
            </mat-form-field>
          </div>
          <div class="col-lg-4 kt-margin-bottom-20-mobile">
            <mat-form-field class="mat-form-field-fluid" appearance="fill">
              <mat-label>{{ 'PATIENT.INPUT.MIDDLE_NAME' | translate }}</mat-label>
              <input
                matInput
                placeholder="Enter Middle Name"
                formControlName="middle_name"
                [ngStyle]="{
                  'background-color': data
                    ? showChanges(prevData.middle_name, nextData.middle_name)
                      ? '#f5ebc4'
                      : ' '
                    : ' '
                }"
              />
            </mat-form-field>
          </div>
          <div class="col-lg-4 kt-margin-bottom-20-mobile">
            <mat-form-field class="mat-form-field-fluid" appearance="fill">
              <mat-label>{{ 'PATIENT.INPUT.LAST_NAME' | translate }}</mat-label>
              <input
                matInput
                placeholder="Enter Last Name"
                formControlName="last_name"
                [ngStyle]="{
                  'background-color': data
                    ? showChanges(prevData.last_name, nextData.last_name)
                      ? '#f5ebc4'
                      : ' '
                    : ''
                }"
              />
              <mat-error
                >{{ 'PATIENT.INPUT.LAST_NAME' | translate }}
                <strong>{{ 'PATIENT.VALIDATION.REQUIRED' | translate }}</strong>
              </mat-error>
            </mat-form-field>
          </div>
          <div class="col-lg-4 kt-margin-bottom-20-mobile">
            <mat-form-field class="mat-form-field-fluid" appearance="fill">
              <mat-label>{{ 'PATIENT.INPUT.LAST_NAME_2' | translate }}</mat-label>
              <input
                matInput
                placeholder="Enter Last Name 2"
                formControlName="last_name2"
                [ngStyle]="{
                  'background-color': data
                    ? showChanges(prevData.last_name2, nextData.last_name2)
                      ? '#f5ebc4'
                      : ''
                    : ''
                }"
              />
            </mat-form-field>
          </div>
          <div class="col-lg-4 kt-margin-bottom-20-mobile">
            <mat-form-field appearance="fill" class="mat-form-field-fluid">
              <mat-label>Nickname/AKA</mat-label>
              <input
                matInput
                formControlName="nickname"
                [ngStyle]="{
                  'background-color': data
                    ? showChanges(prevData.nickname, nextData.nickname)
                      ? '#f5ebc4'
                      : ''
                    : ''
                }"
              />
            </mat-form-field>
          </div>
          <div class="col-lg-2 kt-margin-bottom-20-mobile">
            <mat-form-field appearance="fill" class="mat-form-field-fluid">
              <mat-label>Gender</mat-label>
              <mat-select
                formControlName="gender"
                [ngStyle]="{
                  'background-color': data
                    ? showChanges(prevData.gender, nextData.gender)
                      ? '#f5ebc4'
                      : ''
                    : ''
                }"
              >
                <mat-option value="MALE">Male</mat-option>
                <mat-option value="FEMALE">Female</mat-option>
                <mat-option value="">Undefined</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div class="col-lg-2 kt-margin-bottom-20-mobile">
            <mat-form-field class="mat-form-field-fluid" appearance="fill">
              <mat-label>{{ 'PATIENT.INPUT.DOB' | translate }}</mat-label>
              <input
                matInput
                [matDatepicker]="dob"
                formControlName="dob"
                [max]="maxDate"
                readonly
                (dateChange)="setMaxDate($event)"
                [ngStyle]="{
                  'background-color': data
                    ? showChanges(prevData.dob, nextData.dob)
                      ? '#f5ebc4'
                      : ''
                    : ''
                }"
              />
              <mat-datepicker-toggle matSuffix [for]="dob" *ngIf="!fromHis"></mat-datepicker-toggle>
              <mat-datepicker #dob></mat-datepicker>
              <mat-error *ngIf="isControlHasError('dob', 'required')">
                {{ 'PATIENT.INPUT.DOB' | translate }}
                <strong>{{ 'PATIENT.VALIDATION.REQUIRED' | translate }}</strong>
              </mat-error>
            </mat-form-field>
          </div>
          <div class="col-lg-4 kt-margin-bottom-20-mobile">
            <mat-form-field appearance="fill" class="mat-form-field-fluid">
              <mat-label translate="CONTACT.FORM.EMAIL">Email</mat-label>
              <input
                matInput
                type="email"
                formControlName="email"
                [ngStyle]="{
                  'background-color': data
                    ? showChanges(prevData.email, nextData.email)
                      ? '#f5ebc4'
                      : ''
                    : ''
                }"
              />
              <mat-error *ngIf="isControlHasError('email', 'required')">
                Email is
                <strong>required</strong>
              </mat-error>
              <mat-error *ngIf="isControlHasError('email', 'email')">
                Email is not valid
              </mat-error>
            </mat-form-field>
          </div>

          <div class="col-lg-4 kt-margin-bottom-20-mobile" *ngIf="!data">
            <mat-form-field appearance="fill" class="mat-form-field-fluid">
              <mat-label translate="CONTACT.FORM.ENTITY_TYPE">Entity Type</mat-label>
              <mat-select
                formControlName="entity_type"
                [ngStyle]="{
                  'background-color': data
                    ? showChanges(prevData.entity_type, nextData.entity_type)
                      ? '#f5ebc4'
                      : ''
                    : ''
                }"
              >
                <mat-option value="DOCTOR">Doctor</mat-option>
                <mat-option value="PATIENT">Patient</mat-option>
                <mat-option value="FACILITY">Facility</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div class="col-lg-4 kt-margin-bottom-20-mobile">
            <mat-form-field appearance="fill" class="mat-form-field-fluid">
              <mat-label>Language Preference</mat-label>
              <mat-select
                formControlName="language_preference"
                [ngModel]="languageValue"
                [ngStyle]="{
                  'background-color': data
                    ? showChanges(prevData.language?.language, nextData.language?.language)
                      ? '#f5ebc4'
                      : ''
                    : ''
                }"
              >
                <mat-option *ngFor="let lang of languages" [value]="lang.id">{{
                  lang.language
                }}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div class="col-lg-2 kt-margin-bottom-20-mobile">
            <mat-form-field appearance="fill" class="mat-form-field-fluid">
              <mat-label>PIN</mat-label>
              <input
                matInput
                formControlName="pin_number"
                maxlength="6"
                minlength="4"
                [ngStyle]="{
                  'background-color': data
                    ? showChanges(prevData.pin_number, nextData.pin_number)
                      ? '#f5ebc4'
                      : ''
                    : ''
                }"
              />
              <mat-error *ngIf="isControlHasError('pin_number', 'pattern')">
                <strong>PIN </strong> must be number
              </mat-error>
            </mat-form-field>
          </div>
          <div class="col-lg-3 kt-margin-bottom-20-mobile">
            <div class="mat-form-field-fluid">
              <mat-label class="row ml-1" translate="CONTACT.FORM.CONTACT_STATUS"
                >Contact Status</mat-label
              >
              <mat-slide-toggle class="mr-2" formControlName="isActive"></mat-slide-toggle>
              <mat-hint align="start">
                <strong
                  [ngStyle]="{
                    'background-color': data
                      ? showChanges(prevData.is_active, nextData.is_active)
                        ? '#f5ebc4'
                        : ''
                      : ''
                  }"
                  >{{ getStatusString() }}</strong
                >
              </mat-hint>
            </div>
          </div>
        </div>

        <div class="form-group row cards-inside-doctor-form">
          <div class="col-lg-12 card-header-doctor-form">
            <h4>Contacts</h4>
          </div>
          <div class="col-lg-12 kt-margin-bottom-20-mobile">
            <mat-form-field appearance="fill" class="mat-form-field-fluid">
              <mat-label translate="CONTACT.FORM.CELLPHONE">Cell Phone</mat-label>
              <input
                matInput
                type="tel"
                formControlName="cell_phone"
                maxlength="14"
                ktAppPhoneMask
                [ngStyle]="{
                  'background-color': data
                    ? showChanges(prevData.cell_phone, nextData.cell_phone)
                      ? '#f5ebc4'
                      : ''
                    : ''
                }"
              />
              <mat-error *ngIf="isControlHasError('cell_phone', 'required')">
                Cell Phone is
                <strong>required</strong>
              </mat-error>
              <mat-error *ngIf="isControlHasError('cell_phone', 'pattern')">
                Cell Phone is invalid
              </mat-error>
            </mat-form-field>
          </div>
          <div class="col-lg-4 kt-margin-bottom-20-mobile">
            <mat-form-field appearance="fill" class="mat-form-field-fluid">
              <mat-label>Phone 1</mat-label>
              <input
                matInput
                type="tel"
                formControlName="home_phone"
                maxlength="14"
                ktAppPhoneMask
                [ngStyle]="{
                  'background-color': data
                    ? showChanges(prevData.home_phone, nextData.home_phone)
                      ? '#f5ebc4'
                      : ''
                    : ''
                }"
              />
              <mat-error *ngIf="isControlHasError('home_phone', 'pattern')">
                Phone1 is invalid
              </mat-error>
            </mat-form-field>
          </div>
          <div class="col-lg-4 kt-margin-bottom-20-mobile">
            <mat-form-field appearance="fill" class="mat-form-field-fluid">
              <mat-label>Phone 2</mat-label>
              <input
                matInput
                type="tel"
                formControlName="phone2"
                maxlength="14"
                ktAppPhoneMask
                [ngStyle]="{
                  'background-color': data
                    ? showChanges(prevData.phone2, nextData.phone2)
                      ? '#f5ebc4'
                      : ''
                    : ''
                }"
              />
              <mat-error *ngIf="isControlHasError('phone2', 'pattern')">
                Phone2 is invalid
              </mat-error>
            </mat-form-field>
          </div>
          <div class="col-lg-4 kt-margin-bottom-20-mobile">
            <mat-form-field appearance="fill" class="mat-form-field-fluid">
              <mat-label translate="CONTACT.FORM.FAX">Fax</mat-label>
              <input
                matInput
                type="tel"
                formControlName="fax"
                maxlength="14"
                ktAppPhoneMask
                [ngStyle]="{
                  'background-color': data
                    ? showChanges(prevData.fax, nextData.fax)
                      ? '#f5ebc4'
                      : ''
                    : ''
                }"
              />
              <mat-error *ngIf="isControlHasError('fax', 'required')">
                Fax is
                <strong>required</strong>
              </mat-error>
              <mat-error *ngIf="isControlHasError('fax', 'pattern')"> Fax is invalid </mat-error>
            </mat-form-field>
          </div>
          <div class="col-lg-12 kt-margin-bottom-20-mobile">
            <mat-form-field appearance="fill" class="mat-form-field-fluid">
              <mat-label>Preferred Times</mat-label>
              <input
                matInput
                formControlName="preferred_time"
                [ngStyle]="{
                  'background-color': data
                    ? showChanges(prevData.preferred_time, nextData.preferred_time)
                      ? '#f5ebc4'
                      : ''
                    : ''
                }"
              />
            </mat-form-field>
          </div>
        </div>
        <div class="form-group row cards-inside-doctor-form">
          <div class="col-lg-12 card-header-doctor-form">
            <h4 translate="CONTACT.FORM.ADDRESS">Address</h4>
          </div>
          <div class="col-lg-12 kt-margin-bottom-20-mobile">
            <mat-form-field class="mat-form-field-fluid" appearance="fill">
              <mat-label>{{ 'DOCTOR.INPUT.URBANIZATION' | translate }}</mat-label>
              <input
                matInput
                formControlName="urbanization"
                [ngModel]="urbanizationValue"
                (ngModelChange)="urbanizationValue = $event ? $event.toUpperCase() : ''"
                [ngStyle]="{
                  'background-color': data
                    ? showChanges(prevData.location.urbanization, nextData.location.urbanization)
                      ? '#f5ebc4'
                      : ''
                    : ''
                }"
              />
              <mat-error *ngIf="isControlHasError('urbanization', 'maxlength')">
                Maximum length is 48 character
              </mat-error>
            </mat-form-field>
          </div>
          <div class="col-lg-12 kt-margin-bottom-20-mobile">
            <mat-form-field appearance="fill" class="mat-form-field-fluid">
              <mat-label translate="CONTACT.FORM.ADDRESS1">Address1</mat-label>
              <input
                matInput
                formControlName="address1"
                [ngModel]="Address1Value"
                (ngModelChange)="Address1Value = $event ? $event.toUpperCase() : ''"
                [ngStyle]="{
                  'background-color': data
                    ? showChanges(prevData.location.address1, nextData.location.address1)
                      ? '#f5ebc4'
                      : ''
                    : ''
                }"
              />
              <mat-error *ngIf="isControlHasError('address1', 'maxlength')">
                Maximum length is 48 character
              </mat-error>
            </mat-form-field>
          </div>
          <div class="col-lg-12 kt-margin-bottom-20-mobile">
            <mat-form-field appearance="fill" class="mat-form-field-fluid">
              <mat-label translate="CONTACT.FORM.ADDRESS2">Address2</mat-label>
              <input
                matInput
                formControlName="address2"
                [ngModel]="Address2Value"
                (ngModelChange)="Address2Value = $event ? $event.toUpperCase() : ''"
                [ngStyle]="{
                  'background-color': data
                    ? showChanges(prevData.location.address2, nextData.location.address2)
                      ? '#f5ebc4'
                      : ''
                    : ''
                }"
              />
              <mat-error *ngIf="isControlHasError('address2', 'maxlength')">
                Maximum length is 48 character
              </mat-error>
            </mat-form-field>
          </div>
          <div class="col-lg-4 kt-margin-bottom-20-mobile">
            <mat-form-field appearance="fill" class="mat-form-field-fluid">
              <mat-label translate="CONTACT.FORM.CITY">City</mat-label>
              <input
                matInput
                formControlName="city"
                [ngModel]="cityValue"
                (ngModelChange)="cityValue = $event ? $event.toUpperCase() : ''"
                [ngStyle]="{
                  'background-color': data
                    ? showChanges(prevData.location.city, nextData.location.city)
                      ? '#f5ebc4'
                      : ''
                    : ''
                }"
              />
              <mat-error *ngIf="isControlHasError('city', 'maxlength')">
                Maximum length is 30 character
              </mat-error>
            </mat-form-field>
          </div>
          <div class="col-lg-4 kt-margin-bottom-20-mobile">
            <mat-form-field appearance="fill" class="mat-form-field-fluid">
              <mat-label translate="CONTACT.FORM.STATE">State</mat-label>
              <mat-select
                formControlName="state"
                [ngModel]="stats"
                [ngStyle]="{
                  'background-color': data
                    ? showChanges(prevData.location.state, nextData.location.state)
                      ? '#f5ebc4'
                      : ''
                    : ''
                }"
              >
                <mat-option value="AL">AL</mat-option>
                <mat-option value="AK">AK</mat-option>
                <mat-option value="AR">AR</mat-option>
                <mat-option value="AZ">AZ</mat-option>
                <mat-option value="CA">CA</mat-option>
                <mat-option value="CO">CO</mat-option>
                <mat-option value="CT">CT</mat-option>
                <mat-option value="DC">DC</mat-option>
                <mat-option value="DE">DE</mat-option>
                <mat-option value="FL">FL</mat-option>
                <mat-option value="GA">GA</mat-option>
                <mat-option value="HI">HI</mat-option>
                <mat-option value="IA">IA</mat-option>
                <mat-option value="ID">ID</mat-option>
                <mat-option value="IL">IL</mat-option>
                <mat-option value="IN">IN</mat-option>
                <mat-option value="KS">KS</mat-option>
                <mat-option value="KY">KY</mat-option>
                <mat-option value="LA">LA</mat-option>
                <mat-option value="MA">MA</mat-option>
                <mat-option value="MD">MD</mat-option>
                <mat-option value="ME">ME</mat-option>
                <mat-option value="MI">MI</mat-option>
                <mat-option value="MN">MN</mat-option>
                <mat-option value="MO">MO</mat-option>
                <mat-option value="MS">MS</mat-option>
                <mat-option value="MT">MT</mat-option>
                <mat-option value="NC">NC</mat-option>
                <mat-option value="NE">NE</mat-option>
                <mat-option value="NH">NH</mat-option>
                <mat-option value="NJ">NJ</mat-option>
                <mat-option value="NM">NM</mat-option>
                <mat-option value="NV">NV</mat-option>
                <mat-option value="NY">NY</mat-option>
                <mat-option value="ND">ND</mat-option>
                <mat-option value="OH">OH</mat-option>
                <mat-option value="OK">OK</mat-option>
                <mat-option value="OR">OR</mat-option>
                <mat-option value="PA">PA</mat-option>
                <mat-option value="PR">PR</mat-option>
                <mat-option value="RI">RI</mat-option>
                <mat-option value="SC">SC</mat-option>
                <mat-option value="SD">SD</mat-option>
                <mat-option value="TN">TN</mat-option>
                <mat-option value="TX">TX</mat-option>
                <mat-option value="UT">UT</mat-option>
                <mat-option value="VT">VT</mat-option>
                <mat-option value="VA">VA</mat-option>
                <mat-option value="WA">WA</mat-option>
                <mat-option value="WI">WI</mat-option>
                <mat-option value="WV">WV</mat-option>
                <mat-option value="WY">WY</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div class="col-lg-4 kt-margin-bottom-20-mobile">
            <mat-form-field appearance="fill" class="mat-form-field-fluid">
              <mat-label translate="CONTACT.FORM.ZIP">Zip</mat-label>
              <input
                matInput
                formControlName="zip"
                maxlength="10"
                [ngModel]="zipValue"
                (ngModelChange)="zipValue = $event ? putDash($event) : ''"
                [ngStyle]="{
                  'background-color': data
                    ? showChanges(prevData.location.zip, nextData.location.zip)
                      ? '#f5ebc4'
                      : ''
                    : ''
                }"
              />
              <mat-error *ngIf="isControlHasError('zip', 'pattern')">
                Zip Code is invalid
              </mat-error>
            </mat-form-field>
          </div>
        </div>
        <div class="form-group row cards-inside-doctor-form">
          <div class="col-lg-12 card-header-doctor-form">
            <h4 translate="CONTACT.FORM.OTHER">Other</h4>
          </div>
          <div class="col-lg-12 kt-margin-bottom-20-mobile">
            <mat-form-field appearance="fill" class="mat-form-field-fluid">
              <mat-label translate="CONTACT.FORM.NOTE">Note</mat-label>
              <textarea
                matInput
                rows="7"
                formControlName="note"
                maxlength="10000"
                [ngStyle]="{
                  'background-color': data
                    ? showChanges(prevData.note, nextData.note)
                      ? '#f5ebc4'
                      : ''
                    : ''
                }"
              ></textarea>
              <mat-hint align="end">{{ contactForm.get('note').value?.length || 0 }}/10000</mat-hint>
              <mat-error *ngIf="isControlHasError('note', 'maxlength')">
                Maximum length is 10000 characters
              </mat-error>
            </mat-form-field>
          </div>
        </div>
        <div class="form-group row cards-inside-doctor-form">
          <div class="col-lg-12 card-header-doctor-form">
            <h4>{{ 'MESSAGE.INPUT.TAG' | translate }}</h4>
          </div>
          <div class="col-lg-12 kt-margin-bottom-20-mobile">
            <kt-tags
              [readOnly]="data ? true : false"
              [highlighted]="data ? compareTags(prevData.tags, nextData.tags) : false"
              [readOnlyValue]="readOnlyTags"
              [autocompleteEntity]="'CONTACT'"
              [controlObject]="tags"
              [appearance]="'fill'"
              [value]="tags$"
              category="Entity"
            ></kt-tags>
          </div>
        </div>
      </div>
    </form>
  </div>
  <div class="card-footer" *ngIf="!data">
    <div class="d-flex justify-content-between">
      <div class="mr-2"></div>
      <div>
        <button
          (click)="close()"
          type="button"
          mat-raised-button
          cdkFocusInitial
          matTooltip="Cancel"
        >
          <span translate="GLOBAL.CANCEL">Cancel</span></button
        >&nbsp;
        <button
          type="button"
          mat-raised-button
          color="primary"
          [disabled]="clicked"
          (click)="onSubmit()"
          matTooltip="Create"
        >
          <span translate="GLOBAL.SAVE">Save</span>
        </button>
      </div>
    </div>
  </div>
</div>
